<p-autoComplete
  [(ngModel)]="selectedUsers"
  [multiple]="true"
  [suggestions]="suggestions"
  (completeMethod)="searchUser($event)"
  [forceSelection]="true"
  (onSelect)="handleOnSelect()"
  (onUnselect)="handleOnSelect()"
  optionLabel="id"
  >
  <ng-template let-user pTemplate="item">
    {{ user.givenName }} {{ user.familyName }}
  </ng-template>
  <ng-template let-selectedUser pTemplate="selectedItem">
    {{ selectedUser.givenName }} {{ selectedUser.familyName }}
  </ng-template>
</p-autoComplete>
